import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalUpdateStatusChatPublic",
  tabindex: "-1",
  "aria-labelledby": "chatModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteChat"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-center my-3" }, "トークを公開に戻します。", -1)
const _hoisted_8 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_9 = {
  class: "modal fade",
  id: "modalUpdateStatusChatPrivate",
  tabindex: "-1",
  "aria-labelledby": "chatModal",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "modal-dialog" }
const _hoisted_11 = { class: "modal-content" }
const _hoisted_12 = { class: "modal-header" }
const _hoisted_13 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteChat"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-center my-3" }, "トークを非公開にします。", -1)
const _hoisted_16 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_17 = {
  class: "modal fade",
  id: "updatePrivateSuccess",
  tabindex: "-1",
  "aria-labelledby": "deleteChatSuccess",
  "aria-hidden": "true"
}
const _hoisted_18 = { class: "modal-dialog" }
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = { class: "modal-header" }
const _hoisted_21 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteChatSuccess"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_23 = { class: "text-center my-3" }
const _hoisted_24 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_25 = {
  class: "modal fade",
  id: "updatePublicSuccess",
  tabindex: "-1",
  "aria-labelledby": "deleteChatSuccess",
  "aria-hidden": "true"
}
const _hoisted_26 = { class: "modal-dialog" }
const _hoisted_27 = { class: "modal-content" }
const _hoisted_28 = { class: "modal-header" }
const _hoisted_29 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteChatSuccess"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_31 = { class: "text-center my-3" }
const _hoisted_32 = { class: "modal-footer d-flex justify-content-center" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { CHAT_STORE } from '@/store/constants'
import { ChatStateTypes } from '@/store/modules/chat'
import { computed, ComputedRef } from 'vue-demi'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ref, onMounted } from 'vue'
import chatService from '@/services/chat.services'
import { Modal } from 'bootstrap'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loadingSubmit = ref(false)
const store = useStore()
const route = useRoute()

const messageId = computed<ComputedRef<string>>(() => store.getters[CHAT_STORE.GETTERS.GET_MESSAGE_ID])
const talk_room_data = computed<ComputedRef<Pick<ChatStateTypes, 'talk_room'>>>(() => store.getters[CHAT_STORE.GETTERS.TALK_ROOM])
const handleErrorDelete = ref<boolean>(false)
const updateStatus = async (): void => {
  loadingSubmit.value = true
  let payload = {
    talkroom_id: route.params?.talkroom_id,
    payload: {
      content_id: messageId.value,
      published: !talk_room_data.value?.talk_room?.chat?.find((e) => e.id === messageId.value).published,
      create_by_admin: true,
    },
  }
  try {
    const data = await chatService.updateStatusMessage(payload)
    if (data?.data?.success) {
      store.commit(CHAT_STORE.MUTATIONS.UPDATE_STATUS_MESSAGE, data.data.data)
      handleErrorDelete.value = false
    } else {
      handleErrorDelete.value = true
    }
    setTimeout(() => {
      loadingSubmit.value = false
    }, 2000)
  } catch (error) {
    handleErrorDelete.value = true
  } finally {
    payload.payload.published ? modalCompletedPublic.value?.show() : modalCompletedPrivate.value.show()
    hideModalConfirm(payload.payload.published)
    loadingSubmit.value = false
  }
}

const modalCompletedPublic = ref()
const modalCompletedPrivate = ref()
const modalConfirmPublic = ref()
const modalConfirmPrivate = ref()

const hideModalConfirm = (published) => {
  published ? modalConfirmPublic.value?.hide() : modalConfirmPrivate.value?.hide()
}
onMounted(() => {
  modalCompletedPublic.value = new Modal(document.getElementById('updatePublicSuccess'))
  modalCompletedPrivate.value = new Modal(document.getElementById('updatePrivateSuccess'))
  modalConfirmPublic.value = new Modal(document.getElementById('modalUpdateStatusChatPublic'))
  modalConfirmPrivate.value = new Modal(document.getElementById('modalUpdateStatusChatPrivate'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('confirmPublicTalkAdmin')), 1),
            _hoisted_6
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Button, {
              title: _unref(translate)('cancel'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              class: "me-2"
            }, null, 8, ["title"]),
            _createVNode(Button, {
              title: _unref(translate)('makePublic'),
              type: 'secondary',
              onClick: updateStatus,
              loading: loadingSubmit.value,
              disabled: loadingSubmit.value
            }, null, 8, ["title", "loading", "disabled"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h5", _hoisted_13, _toDisplayString(_unref(translate)('privateTalkAdmin')), 1),
            _hoisted_14
          ]),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createVNode(Button, {
              title: _unref(translate)('cancel'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              class: "me-2"
            }, null, 8, ["title"]),
            _createVNode(Button, {
              title: _unref(translate)('keepPrivate'),
              type: 'secondary',
              onClick: updateStatus,
              loading: loadingSubmit.value,
              disabled: loadingSubmit.value
            }, null, 8, ["title", "loading", "disabled"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h5", _hoisted_21, _toDisplayString(_unref(translate)('privateChangedAdmin')), 1),
            _hoisted_22
          ]),
          _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(translate)(handleErrorDelete.value ? 'OD65PrivateError' : 'OD65PrivateSuccess')), 1),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              class: "me-2"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("h5", _hoisted_29, _toDisplayString(_unref(translate)('publicTalkAdmin')), 1),
            _hoisted_30
          ]),
          _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(translate)(handleErrorDelete.value ? 'OD65PublishError' : 'OD65PublishSuccess')), 1),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              class: "me-2"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})